import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleSafeBuying() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="bg-background-50">
      <article>
        <header className="w-full px-6 md:px-10 pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-500 transition-colors mb-6">
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              <span>На главную</span>
            </Link>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">Безопасность</span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Безопасные покупки из Китая: как не попасть на мошенников
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
              Проверенные способы защиты при заказе из Китая. Как YOYBUY Spreadsheet исключает риски и защищает ваши заказы.
            </p>
            <div className="mt-6 flex items-center gap-4 text-xs text-foreground-400">
              <span>Обновлено: Июль 2026</span>
              <span>·</span>
              <span>Время чтения: 6 минут</span>
            </div>
          </div>
        </header>

        <div className="w-full px-6 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">

            <img
              src="https://readdy.ai/api/search-image?query=Shield%20icon%20made%20of%20warm%20golden%20light%20protecting%20a%20shopping%20cart%20on%20dark%20background%2C%20cybersecurity%20meets%20ecommerce%20concept%2C%20warm%20protective%20glow%20radiating%20outward%2C%20trust%20and%20safety%20metaphor%2C%20editorial%20tech-security%20photography%2C%20comforting%20atmosphere%20of%20protection&width=1200&height=600&seq=yoybuy-art-safety-hero&orientation=landscape"
              alt="Безопасные покупки из Китая"
              className="w-full rounded-3xl mb-10 object-cover"
            />

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Основные риски при покупках из Китая</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Заказ товаров из Китая может быть связан с определёнными рисками: недобросовестные продавцы, несоответствие товара описанию, скрытые комиссии и проблемы с доставкой. Однако эти риски можно свести к минимуму, если использовать проверенные инструменты.
              </p>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                <strong>YOYBUY Spreadsheet</strong> создан именно для того, чтобы исключить основные риски. Все товары в таблицах на <Link to="/" className="text-accent-500 hover:underline">YOYBUY.PRO</Link> проходят предварительную проверку, а цены и наличие обновляются ежедневно. Вы всегда видите актуальную информацию.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">5 правил безопасных покупок</h2>
              <div className="space-y-4">
                {[
                  { num: '1', title: 'Проверяйте продавца', text: 'Работайте только с проверенными поставщиками. В таблицах YOYBUY Spreadsheet собраны товары от надёжных продавцов с подтверждённой историей. Это исключает риск нарваться на мошенника.' },
                  { num: '2', title: 'Изучайте отзывы и рейтинги', text: 'Перед заказом всегда смотрите отзывы других покупателей. В таблицах YOYBUY для каждого товара указан рейтинг продавца и количество успешных сделок.' },
                  { num: '3', title: 'Сравнивайте цены', text: 'Слишком низкая цена — повод насторожиться. Сравнивайте стоимость аналогичных товаров. Если цена значительно ниже рыночной, это может быть признаком подделки или мошенничества.' },
                  { num: '4', title: 'Используйте безопасные способы оплаты', text: 'Оплачивайте заказы через платформу Kaspreadsheet, которая обеспечивает защиту платежа. Избегайте прямых переводов на счета продавцов.' },
                  { num: '5', title: 'Сохраняйте документацию', text: 'Сохраняйте все подтверждения заказа, скриншоты переписки и трек-номера. В случае спора эта информация поможет доказать вашу правоту.' },
                ].map((item) => (
                  <div key={item.num} className="flex gap-4 p-5 bg-background-100 rounded-2xl">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-sm font-bold">{item.num}</span>
                    <div>
                      <h4 className="text-base font-semibold text-foreground-800 mb-1">{item.title}</h4>
                      <p className="text-sm text-foreground-500 leading-relaxed">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Как YOYBUY Spreadsheet защищает ваш заказ</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Главное преимущество системы таблиц — прозрачность. Вы видите реальные цены, актуальное наличие и полную информацию о товаре до того, как сделаете заказ. Никаких скрытых платежей и неожиданных сюрпризов.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  { icon: 'ri-shield-check-line', title: 'Проверенные поставщики', text: 'Все товары в таблицах от верифицированных продавцов с хорошей репутацией.' },
                  { icon: 'ri-refresh-line', title: 'Актуальные данные', text: 'Цены и наличие обновляются ежедневно — никакой устаревшей информации.' },
                  { icon: 'ri-file-list-3-line', title: 'Полная информация', text: 'Размеры, цвета, материалы, стоимость доставки — всё указано в таблице.' },
                  { icon: 'ri-customer-service-2-line', title: 'Поддержка', text: 'Платформа Kaspreadsheet обеспечивает поддержку на всех этапах заказа.' },
                ].map((item, i) => (
                  <div key={i} className="p-4 bg-accent-50 rounded-2xl">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                      <i className={`${item.icon} text-accent-600`}></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-800 mb-1">{item.title}</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.text}</p>
                  </div>
                ))}
              </div>
            </section>

            <div className="mt-14 p-8 bg-primary-500 rounded-3xl text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">Покупайте безопасно</h2>
              <p className="text-base text-background-50/80 mb-6 max-w-md mx-auto">
                YOYBUY Spreadsheet — ваш надёжный инструмент для безопасных покупок из Китая.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-7 py-3.5 rounded-full bg-background-50 text-primary-600 text-sm font-semibold hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>YOYBUY SHEET</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link to="/" className="px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-sm font-semibold hover:border-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>На главную</span>
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-background-200">
              <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-400 hover:text-accent-500 transition-colors">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                <span>← Вернуться на главную страницу YOYBUY.PRO</span>
              </Link>
            </div>
          </div>
        </div>
      </article>

      <footer className="w-full px-6 md:px-10 py-10 bg-foreground-950">
        <div className="max-w-3xl mx-auto text-center">
          <Link to="/" className="text-xl font-heading font-bold text-background-50">YOYBUY<span className="text-accent-500">.PRO</span></Link>
          <p className="mt-3 text-xs text-background-50/30">© 2026 YOYBUY.PRO. Все права защищены.</p>
        </div>
      </footer>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org", "@type": "Article",
          "headline": "Безопасные покупки из Китая: как не попасть на мошенников",
          "description": "Проверенные способы защиты при заказе из Китая. Как YOYBUY Spreadsheet исключает риски.",
          "datePublished": "2026-07-05", "dateModified": "2026-07-05",
          "author": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "publisher": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "mainEntityOfPage": {"@type": "WebPage", "@id": `${import.meta.env.VITE_SITE_URL}/article/safe-china-buying`}
        })}
      </script>
    </main>
  );
}